import { CardMenu } from '../types';
import {
    ListItemIcon,
    ListItemText,
    MenuItem as MuiMenuItem,
} from '@mui/material';

const MenuItem: React.FC<
    CardMenu & { onClick: () => void; disabled?: boolean }
> = ({ route, label, icon, ...rest }) => {
    return (
        <MuiMenuItem {...rest}>
            <ListItemIcon
                sx={{
                    color: 'text.primary',
                }}>
                {icon}
            </ListItemIcon>
            <ListItemText sx={{ span: { fontSize: '0.8rem' } }}>
                {label}
            </ListItemText>
        </MuiMenuItem>
    );
};

export default MenuItem;
